import React from "react";
import PropTypes from "prop-types";
import InputText from "shared/components/inputs/InputText";
import InputSelect from "shared/components/inputs/InputSelect";
import "./style.scss";

export default function TabInfo({ videoDescription }) {
    return videoDescription && (
        <div className="admin-info">
            <div className="tab-info">
                <div className="section-general">
                    <h2>Video Description</h2>
                </div>

                <div className="divider" />

                <InputText
                    name="videoDescriptionTitle"
                    label="Title"
                    value={videoDescription.title || ""}
                    readOnly
                    rules={{ required: true }}
                />

                <InputText
                    name="videoDescriptionDescription"
                    label="Description"
                    value={videoDescription.description || ""}
                    readOnly
                    rules={{ required: true }}
                    multiline
                    minRows={5}
                />

                <InputSelect
                    name="videoDescriptionPublished"
                    label="Publish Status"
                    value={videoDescription.published ? "PUBLISHED" : "DRAFT"}
                    disabled
                    items={[
                        { value: "DRAFT", label: "Draft" },
                        { value: "PUBLISHED", label: "Published" }
                    ]}
                />

                <InputText
                    name="videoDescriptionVideoUrl"
                    label="Video URL"
                    value={videoDescription.videoUrl || ""}
                    readOnly
                />
            </div>
        </div>
    );
}

TabInfo.propTypes = {
    videoDescription: PropTypes.object
};
